import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../transl/en.json"
import hr from "../transl/hr.json"

i18next.use(initReactI18next).init({
	resources: {
		en: {
			translation: en,
		},
		hr: {
			translation: hr,
		},
	},
	lng: localStorage.getItem("lng") || "en",
});

export default i18next;